module.exports = "pegasus/assets/themelp1/health/104.png";